import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { SharedStorageService } from 'ngx-store';
import Swal from 'sweetalert2';
import { SharedService } from '../../core/services/store/shared-store/shared-storage.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { JwtHelperService } from '@auth0/angular-jwt';

import find from 'lodash/find';

@Injectable()
export class Utils {
  private jwtHelper: JwtHelperService = new JwtHelperService();
  constructor(
    private router: Router,
    private sharedStorageService: SharedStorageService,
    private sharedService: SharedService,
    private oauthService: OAuthService
  ) {}

  // set where you are on the side bar
  setSelectedRoute(currentRoute: string) {
    const DEFAULT_BTN_CLASS = 'w3-bar-item btn-nav';
    // uses the router to see how many routs ther are and see with one you selected/ and are on when page loads;

    this.router.config[1].children[0].children.forEach((element) => {
      // see current path is in the routs and chang the css to indicate where you are;
      if (element.path === currentRoute) {
        document.getElementById(currentRoute).className = DEFAULT_BTN_CLASS + ' navSelected';
        // set current tabs title to route
        document.getElementById('appComponenFlowTitle').innerHTML =
          this.upperCasefirstChar(currentRoute);
        // just set the css to the default;
      } else {
        document.getElementById(element.path).className = DEFAULT_BTN_CLASS;
      }

      if (currentRoute === '/') {
        document.getElementById('appComponenFlowTitle').innerHTML = '';
      }
    });
  }

  startCountDown(
    elementID: string,
    svgID: string,
    pulseID: string,
    seconds: number,
    warningStart: number
  ) {
    // get element to add the timer
    const countdownNumberEl = document.getElementById(elementID);
    // countdownNumberEl.style.visibility = 'visible';
    const time: number = seconds;

    // convert time to a string "30s"
    const timeString = time.toString() + 's';

    // get svg Circle by id
    const svgCircle = document.getElementById(svgID);
    // svgCircle.style.visibility = 'visible';

    // add animation to the svg Circle
    svgCircle.style.animation = 'countdownTimer ' + timeString + ' linear forwards';

    // get timer pulse
    const timerPulse = document.getElementById(pulseID);
    // add animation to timer pulse

    countdownNumberEl.textContent = seconds.toString();

    let countdownInterval;
    // start count down
    return (countdownInterval = setInterval(() => {
      seconds = --seconds <= -1 ? time : seconds;
      countdownNumberEl.textContent = seconds.toString();
      if (seconds === 0) {
        // remove animation
        svgCircle.style.animation = '';
        // timerPulse.style.animation = "";

        // stop count down
        clearInterval(countdownInterval);
        // alert('time is up')
      }

      if (seconds === warningStart) {
        timerPulse.style.animation = 'countdownPulse 1s ease-out ' + warningStart.toString();
        countdownNumberEl.style.color = 'var(--paydRed)';
      }
    }, 1000));
  }

  restAnimation(elementId: string, className: string) {
    const animation = document.getElementById(elementId);
    // //removing the class
    animation.classList.remove(className);
    // -> triggering reflow /* The actual magic */
    // without this it wouldn't work. Try uncommenting the line and the transition won't be retriggered.
    // tslint:disable-next-line:no-unused-expression
    void animation.offsetWidth;
    // re-adding the class
    animation.classList.add(className);
  }

  upperCasefirstChar(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  alphabeticallyOrderMap(a, b): any {
    const nameA = a.toUpperCase(); // ignore upper and lowercase
    const nameB = b.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  }

  addChannelTooltips(channels: any, channelId: string): any {
    if (document.getElementById(channelId)) {
      channels.forEach((channel) => {
        const config = channel.config;
        const channelElement = document.getElementById(config['channel-id']);
        channelElement.setAttribute('data-balloon', config['channel-name']);
      });
    } else {
      setTimeout(() => this.addChannelTooltips(channels, channelId), 1000);
    }
  }

  firstChannelId(channels: any) {
    if (channels) {
      const firstChild = channels[0];
      return firstChild.config['channel-id'];
    }
  }

  currentTabId() : string {
    return isNaN(sessionStorage.tabId) ?
        (sessionStorage.tabId = (Math.floor(Math.random() * 1000000000)).toString()) : sessionStorage.tabId;
  }

  getUrlParameter(url) {
    if (url) {
      const urlIndex = url.indexOf('?');
      if (urlIndex !== -1) {
        const parameters = [];
        let hash;
        const hashes = url.slice(urlIndex + 1).split('&');
        for (let i = 0; i < hashes.length; i++) {
          hash = hashes[i].split('=');
          parameters.push({ [hash[0]]: hash[1] });
        }
        return parameters;
      }
    }
  }

  setId(clientId) {
    this.sharedStorageService.set('setId', clientId);
  }

  getId(): string {
    return this.sharedStorageService.get('setId');
  }

  getUserInfo(): any {
    if (this.sharedService.getUserInfo() == null) {
      if (this.oauthService.getIdToken) {
        const idToken = this.jwtHelper.decodeToken(this.oauthService.getIdToken());
        const userInfo = {
          name: idToken['name'],
          user_id: idToken['email'],
          id: idToken['id'],
        };

        const thirdPartyTouch: any = find(idToken['thirdParties'], (o) => {
          return o.solution === 'TOUCH_FLOW' || o.solution === 'TOUCH_FLOW_ADMIN';
        });

        if (thirdPartyTouch) {
          if (isNaN(Number(thirdPartyTouch['externalId']))) {
            // legacy format, json composite type
            const externalId = JSON.parse(thirdPartyTouch['externalId']);
            if (externalId) {
              if (externalId.id) {
                userInfo['clientId'] = externalId.id;
              }
              if (externalId.type) {
                userInfo['entityType'] = externalId.type;
              }
            }
          } else {
            // If it looks like a number then assume entity type CLIENT
            userInfo['clientId'] = thirdPartyTouch['externalId'];
            userInfo['entityType'] = 'CLIENT';
          }
        } else {
          this.oauthService.logOut();
        }

        const roles = new Map<string, string>();
        idToken['roles'].forEach((role) => {
          roles.set(role, role);
        });
        userInfo['permissions'] = roles;
        this.setShareStorage(userInfo);
        this.sharedService.setLoggedIn(true);
      }
    }
    return this.sharedService.getUserInfo();
  }

  setShareStorage(userInfo: {}) {
    this.sharedService.setUserAccessToken = window.localStorage.getItem('ngx_id_token');
    this.sharedService.setAccessToken = window.localStorage.getItem('ngx_access_token');
    this.sharedService.setEntityId(userInfo['clientId']);
    this.sharedService.setEntityType(userInfo['entityType']);
    this.sharedService.setUserInfo(userInfo);
    this.sharedService.setEnvironment('dev');
  }
}

export const swalMini: any = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 5000,
});

export const swalConfirm: any = Swal.mixin({
  type: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
});

export const swalWarning: any = Swal.mixin({
  type: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
});

export const swalMiniBottom: any = Swal.mixin({
  toast: true,
  position: 'bottom',
  showConfirmButton: false,
  timer: 5000,
});

export const swalWarningBottom: any = Swal.mixin({
  type: 'warning',
  toast: true,
  position: 'bottom',
  showConfirmButton: false,
  timer: 5000,
});

export const swalWarningTop: any = Swal.mixin({
  type: 'warning',
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 5000,
});
